import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import {
  QUEUE_SYMBOLS,
  RANK_SYMBOL_TO_STR,
  ROLE_SYMBOL_TO_STR,
} from "@/game-lol/constants/constants.mjs";
import * as GraphQLTemplatesDatalake from "@/game-lol/graphql-templates-datalake.mjs";
import ChampionsStats from "@/game-lol/models/lol-champions-stats.mjs";
import QueueSymbol, {
  getQueueDetails,
} from "@/game-lol/utils/symbol-queue.mjs";
import { RankSymbol } from "@/game-lol/utils/symbol-rank.mjs";
import RoleSymbol from "@/game-lol/utils/symbol-role.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";

// Champions stats
// Plural (all champions)
// State location: ["lol", "championsStats", urlParams.toString()]

function queryChampionsStats(variables: {
  queue: string;
  tier?: string;
  role?: string;
  region?: string;
}) {
  const params = {
    queue: getQueueDetails(QueueSymbol(variables.queue))?.gql,
    tier:
      variables.tier && RankSymbol(variables?.tier)
        ? RANK_SYMBOL_TO_STR[RankSymbol(variables?.tier)]?.gql
        : null,
    role: null,
    region: null,
  };

  if (
    QueueSymbol(params.queue) !== QUEUE_SYMBOLS.rankedSoloDuo &&
    QueueSymbol(params.queue) !== QUEUE_SYMBOLS.rankedFlex
  ) {
    delete params.tier;
  }

  if (variables.region) {
    params.region = variables.region;
  } else if (!params.region) {
    delete params.region;
  }

  if (variables.role) {
    params.role = ROLE_SYMBOL_TO_STR[RoleSymbol(variables?.role)]?.gql;
  } else if (!params.role) {
    delete params.role;
  }

  return queryGQL(
    appURLs.DATALAKE,
    GraphQLTemplatesDatalake.ChampionsStats,
    params,
  );
}

export default function ({
  filters,
  urlParams,
  options = {},
}: {
  filters: {
    queue: string;
    region?: string;
    tier?: string;
    role?: string;
  };
  urlParams: URLSearchParams;
  options;
}) {
  return getData(
    queryChampionsStats(filters),
    ChampionsStats,
    ["lol", "championsStats", urlParams.toString()],
    {
      ...options,
      // shouldFetchIfPathExists: false,
      // expiryTime: Date.now() + 2 * 60 * 60 * 1000, // 2 hours
    },
  );
}
